import { OrderKinds } from './enums';
import type { Order } from './types';

export function filterDeliveryOrders(orders: Order[]) {
  return orders.filter((order) => order.kind === OrderKinds.DELIVERY);
}

export function filterByConfiguredOrderKinds(
  orders: Order[],
  selectedOrderKinds: Order['kind'][],
  isSelectedAllOrderKinds: boolean,
) {
  return isSelectedAllOrderKinds
    ? orders
    : orders.filter((order) => selectedOrderKinds.includes(order.kind));
}

export function filterByOrderKinds(
  orders: Order[],
  selectedOrderKinds: Order['kind'][],
  isSelectedAllOrderKinds: boolean,
  isDeliveryOnlyEnabled: boolean,
) {
  if (isDeliveryOnlyEnabled) {
    return filterDeliveryOrders(orders);
  }

  return filterByConfiguredOrderKinds(
    orders,
    selectedOrderKinds,
    isSelectedAllOrderKinds,
  );
}
